"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _actions = require("egov-ui-framework/ui-redux/app/actions");

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _api = require("egov-ui-framework/ui-utils/api");

var _actions3 = require("egov-ui-kit/redux/common/actions");

var _commons = require("egov-ui-framework/ui-utils/commons");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiddleWare = function (_Component) {
  (0, _inherits3.default)(MiddleWare, _Component);

  function MiddleWare() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MiddleWare);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MiddleWare.__proto__ || Object.getPrototypeOf(MiddleWare)).call.apply(_ref, [this].concat(args))), _this), _this.getBusinessServiceMdmsData = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(tenantId) {
        var prepareFinalObject, mdmsBody, payload;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                prepareFinalObject = _this.props.prepareFinalObject;
                mdmsBody = {
                  MdmsCriteria: {
                    tenantId: tenantId,
                    moduleDetails: [{
                      moduleName: "BillingService",
                      masterDetails: [{ name: "BusinessService" }]
                    }, {
                      moduleName: "common-masters",
                      masterDetails: [{ name: "uiCommonPay" }]
                    }]
                  }
                };
                _context.prev = 2;
                payload = null;
                _context.next = 6;
                return (0, _api.httpRequest)("post", "/egov-mdms-service/v1/_search", "_search", [], mdmsBody);

              case 6:
                payload = _context.sent;

                prepareFinalObject("businessServiceMdmsData", payload.MdmsRes);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

                console.log(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 10]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.checkPublicSearch = function () {
      return (0, _commons.isPublicSearch)();
    }, _this.componentDidMount = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var search, _this$props, reduxObj, prepareFinalObject, txnQuery, isPublicSearch, pageType, accountNo, txnId, pgUpdateResponse, consumerCode, tenantId, receiptNo, url, ackFailureUrl, srcQuery, businessService, transactionId, moduleName, _url, ackSuccessUrl;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              search = _this.props.location.search;
              _this$props = _this.props, reduxObj = _this$props.reduxObj, prepareFinalObject = _this$props.prepareFinalObject;
              txnQuery = search.split("&")[0].replace("eg_pg_txnid", "txnid");
              isPublicSearch = _this.checkPublicSearch();
              pageType = localStorage.getItem("formType") || "";
              accountNo = localStorage.getItem("accountNo") || "";
              txnId = pageType === "water" || pageType === "miscWater" || pageType === "drainage" ? localStorage.getItem("TransactionIDD") : Number(localStorage.getItem("TransactionIDD"));
              _context2.prev = 7;

              _store2.default.dispatch((0, _actions3.showSpinner)());
              _context2.next = 11;
              return (0, _api.httpRequest)("post", "pg-service/transaction/PT/v1/_update?txnid=" + txnId, "_update", [], {});

            case 11:
              pgUpdateResponse = _context2.sent;
              consumerCode = (0, _get2.default)(pgUpdateResponse, "Transaction[0].consumerCode");
              tenantId = (0, _get2.default)(pgUpdateResponse, "Transaction[0].tenantId");
              receiptNo = (0, _get2.default)(pgUpdateResponse, "Transaction[0].receipt");

              if ((0, _get2.default)(pgUpdateResponse, "Transaction[0].txnStatus") === "FAILURE") {
                url = "/withoutAuth/acknowledgement?status=" + "failure" + "&consumerCode=" + consumerCode + "&tenantId=" + tenantId + "&businessService=" + (0, _get2.default)(pgUpdateResponse, "Transaction[0].module", localStorage.getItem("pay-businessService"));
                ackFailureUrl = isPublicSearch ? "/withoutAuth" + url : url;

                _this.props.setRoute(url);
                _store2.default.dispatch((0, _actions3.hideSpinner)());
              } else {
                srcQuery = "?tenantId=" + tenantId + "&consumerCodes=" + consumerCode;
                businessService = "PT";
                // let transactionId = get(searchResponse, "Payments[0].paymentDetails[0].receiptNumber");

                transactionId = pgUpdateResponse.Transaction[0].txnId;
                moduleName = "egov-common";

                // const url = `/${moduleName}/acknowledgement?status=${"success"}&consumerCode=${123}&tenantId=$km.kolkata&receiptNumber=${txnId}&businessService="PT"&purpose=${"pay"}`;
                // const ackSuccessUrl = isPublicSearch ? (dept() ? `/withoutAuth${waterUrl}` : `/withoutAuth${url}`) : dept() ? waterUrl : url;

                _url = "/withoutAuth/acknowledgement?status=" + "success" + "&consumerCode=" + 123 + "&tenantId=$km.kolkata&receiptNumber=" + txnId + "&businessService=\"PT\"&purpose=" + "pay";
                ackSuccessUrl = "withoutAuth/acknowledgement";

                _this.props.setRoute(_url);
                _store2.default.dispatch((0, _actions3.hideSpinner)());
              }
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](7);

              alert(_context2.t0);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[7, 18]]);
    })), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  //   withoutAuth/acknowledgement


  (0, _createClass3.default)(MiddleWare, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("div", null);
    }
  }]);
  return MiddleWare;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  var reduxObj = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject");
  return { reduxObj: reduxObj };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setRoute: function setRoute(route) {
      return dispatch((0, _actions.setRoute)(route));
    },
    prepareFinalObject: function prepareFinalObject(jsonPath, value) {
      return dispatch((0, _actions2.prepareFinalObject)(jsonPath, value));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)(MiddleWare));


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/common/OnlinePayment/paymentRedirectPage.js
// module id = 3361
// module chunks = 1137